import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private initialHttpUrl: string[] = []; 
  public showLoader: BehaviorSubject<string[]> = new BehaviorSubject(this.initialHttpUrl);

  constructor() { }

  public getState(): Observable<string[]> {
    return this.showLoader.asObservable();
  }
  public addRequest(url:string): void {
    let httpUrls = this.showLoader.value;
    if (httpUrls) {
      httpUrls.push(url);
    }
    this.showLoader.next(httpUrls);
  }
  public removeRequest(url: string): void {
    let httpUrls = this.showLoader.value;
    if (httpUrls) {
      const index = httpUrls.findIndex(httpUrl => httpUrl === url);
      if (index !== -1) {
        httpUrls.splice(index, 1);
      }
    }
    this.showLoader.next(httpUrls);
  }
}
